import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface LabelValueProps {
    icon?: ReactNode;
    label?: string;
    value: string | number | React.ReactNode;
    variant?: 'caption' | 'body2';
    color?: string;
    gap?: number;
    alignItems?: 'center' | 'flex-start' | 'flex-end';
    flex?: number;
}

export const LabelValueColumn = ({
    icon,
    label,
    value,
    variant = 'body2',
    color = 'textSecondary',
    gap = 0.5,
    alignItems = 'flex-start',
}: LabelValueProps) => {
    return (
        <Stack
            direction={'column'}
            gap={gap}
            alignItems={alignItems}
            paddingTop={0.5}
        >
            <Stack direction={'row'} gap={gap} alignItems={alignItems}>
                {icon}
                {label && (
                    <Typography color={color} variant="caption" flexShrink={0}>
                        {label} :
                    </Typography>
                )}
            </Stack>
            {typeof value === 'string' || typeof value === 'number' ? (
                <Typography variant={variant} flex={1}>
                    {value}
                </Typography>
            ) : (
                <Box width={'100%'}>{value}</Box>
            )}
        </Stack>
    );
};
